import { SignalSubjectDocType, signalSubjectDocTypes } from "@megaron/docs-contracts";

export const signalSubjectDocTypeLabel: Record<SignalSubjectDocType, string> = {
  customer: "Klient",
  "invoice-thread": "Wątek faktury",
  "invoice-draft": "Wersja robocza faktury",
  "support-ticket": "Zgłoszenie",
  "fulfillment-order": "Zamówienie",
  "sync-channel": "Synchronizacja",
};

export const signalSubjectDocTypeOptions = signalSubjectDocTypes.map((subjectDocType) => ({
  label: signalSubjectDocTypeLabel[subjectDocType],
  value: subjectDocType,
}));
